GraphQL ID: presetDistribution
list:
  # button not shown; used for no-op templates
  - name: None
    value:
      {
        "values2": { "Power": 0, "Power2": 0, "Burning": 0, "Bleeding": 0, "Poisoned": 0, "Torment": 0, "Confusion": 0 }
      }
    noCreditOkay: true

  - name: 100% Power
    value:
      {
        "values2": { "Power": 3000, "Power2": 0, "Burning": 0, "Bleeding": 0, "Poisoned": 0, "Torment": 0, "Confusion": 0 }
      }
    noCreditOkay: true

  # Uses air/hydro sigils, somewhat taken into consideration by giving air a
  # proc rate high enough to match air+hydro damage
  - name: Power Berserker GS A/A
    profession: Berserker
    value:
      {
        "values2": { "Power": 3871, "Power2": 0, "Burning": 0, "Bleeding": 0, "Poisoned": 0, "Torment": 0, "Confusion": 0 }
      }
    credit:
      - author: Linsi
        url: https://www.youtube.com/watch?v=nI-Y6GsZvUQ
        log: https://dps.report/fLGV-20240202-220024_golem

  # Uses air/hydro sigils, somewhat taken into consideration by giving air a
  # proc rate high enough to match air+hydro damage
  - name: Quickness Power Berserker GS A/A
    profession: Berserker
    value:
      {
        "values2": { "Power": 3829, "Power2": 0, "Burning": 0, "Bleeding": 0, "Poisoned": 0, "Torment": 0, "Confusion": 0 }
      }
    credit:
      - author: Linsi
        url: https://www.youtube.com/watch?v=HzFEwIXT5Nw
        log: https://dps.report/LLcD-20240203-030534_golem

  - name: Power Spellbreaker S/M D/A
    profession: Spellbreaker
    value:
      {
        "values2": { "Power": 3351, "Power2": 0, "Burning": 0, "Bleeding": 9.31, "Poisoned": 0, "Torment": 0, "Confusion": 0 }
      }
    credit:
      - author: Sotym
        url: https://www.youtube.com/watch?v=wp_fDXvh99o
        log: https://dps.report/QYqB-20250217-174213_golem

  - name: Power Spellbreaker Hammer
    profession: Spellbreaker
    value:
      {
        "values2": { "Power": 3087, "Power2": 0, "Burning": 0, "Bleeding": 0, "Poisoned": 0, "Torment": 0, "Confusion": 0 }
      }
    credit:
      - author: Rumi
        url: https://www.youtube.com/watch?v=1VLEuetvokg
        log: https://dps.report/vdip-20250624-231442_golem

  # includes sigils
  - name: Condi Quickness Berserker Blademaster
    profession: Berserker
    value:
      {
        "values2": { "Power": 2438, "Power2": 0, "Burning": 8.82, "Bleeding": 14.13, "Poisoned": 2.1, "Torment": 3.64, "Confusion": 0 }
      }
    credit:
      - author: 'Saint Mighty'
        url: https://www.youtube.com/watch?v=hHBBZwsdN7k
        log: https://dps.report/tNb1-20231014-165434_golem

  # includes sigils
  - name: Condi Berserker UF
    profession: Berserker
    value:
      {
        "values2": { "Power": 2274, "Power2": 0, "Burning": 10.93, "Bleeding": 12.95, "Poisoned": 2.12, "Torment": 1.78, "Confusion": 0 }
      }
    credit:
      - author: 'Costa Primo'
        url: https://www.youtube.com/watch?v=wMtYIqSivxY
        log: https://dps.report/xPFw-20250217-171746_golem

  # includes sigils
  - name: Condi Berserker Blademaster
    profession: Berserker
    value:
      {
        "values2": { "Power": 2470, "Power2": 0, "Burning": 8.29, "Bleeding": 13.67, "Poisoned": 2.15, "Torment": 5.11, "Confusion": 0 }
      }
    credit:
      - author: 'Costa Primo'
        url: https://www.youtube.com/watch?v=Cg52M5WGU5o
        log: https://dps.report/RzZh-20231014-102529_golem

  # 100% crit
  - name: Alacrity Power Bladesworn Signets
    profession: Bladesworn
    value:
      {
        "values2": { "Power": 4003, "Power2": 0, "Burning": 0, "Bleeding": 5.95, "Poisoned": 0, "Torment": 1.52, "Confusion": 0 }
      }
    credit:
      - author: Evo
        url: https://www.youtube.com/watch?v=QWj7r5AAGrA
        log: https://dps.report/Tm53-20250629-002028_golem

  - name: Alacrity Power Bladesworn
    profession: Bladesworn
    value:
      {
        "values2": { "Power": 4639, "Power2": 0, "Burning": 0, "Bleeding": 4.17, "Poisoned": 0, "Torment": 1.54, "Confusion": 0 }
      }
    credit:
      - author: Evo
        url: https://www.youtube.com/watch?v=ug3kze2ejdQ
        log: https://dps.report/JvTL-20250827-204709_golem

  - name: Power Bladesworn
    profession: Bladesworn
    value:
      {
        "values2": { "Power": 5468, "Power2": 0, "Burning": 0, "Bleeding": 3.6, "Poisoned": 0, "Torment": 1.6, "Confusion": 0 }
      }
    credit:
      - author: Evo
        url: https://www.youtube.com/watch?v=tsAiu-GGq3I
        log: https://dps.report/3QR7-20250821-063721_golem

  - name: Hybrid Paragon S/S
    profession: Paragon
    value:
      {
        "values2": { "Power": 3045, "Power2": 0, "Burning": 0.37, "Bleeding": 21.6, "Poisoned": 0, "Torment": 3.78, "Confusion": 0 }
      }
    credit:
      - author: Arzon
        url: https://www.youtube.com/watch?v=Mz6yBWIcbtQ
        log: https://gw2wingman.nevermindcreations.de/log/31aaf-20251215-034716_StdGolem_kill
        # log: https://dps.report/RS7D-20251215-034716_golem

  - name: Power Dragonhunter Radiance SP/GS
    profession: Dragonhunter
    value:
      {
        "values2": { "Power": 3959, "Power2": 0, "Burning": 1.53, "Bleeding": 0, "Poisoned": 0, "Torment": 0, "Confusion": 0 }
      }
    credit:
      - author: Derm
        url: https://www.youtube.com/watch?v=0drJ3WOpTLM
        log: https://dps.report/so5x-20260418-005724_golem

  - name: Power Dragonhunter Virtues SP/GS
    profession: Dragonhunter
    value:
      {
        "values2": { "Power": 4032, "Power2": 0, "Burning": 1.69, "Bleeding": 0, "Poisoned": 0, "Torment": 0, "Confusion": 0 }
      }
    credit:
      - author: Derm
        url: https://www.youtube.com/watch?v=N7fnAgJhy94
        log: https://dps.report/geOw-20250626-225051_golem

  # (this is actually an old core guardian distribution iirc)
  - name: Power Quickbrand (approx.)
    profession: Firebrand
    value:
      {
        "values2": { "Power": 3390, "Power2": 0, "Burning": 1.1, "Bleeding": 0, "Poisoned": 0, "Torment": 0, "Confusion": 0 }
      }
    noCreditOkay: true

  - name: Condi Willbender P/T P/P
    profession: Willbender
    value:
      {
        "values2": { "Power": 2191, "Power2": 0, "Burning": 15.64, "Bleeding": 6.3, "Poisoned": 0, "Torment": 1.37, "Confusion": 0 }
      }
    credit:
      - author: Mastro
        url: https://www.youtube.com/watch?v=V5EE-avWJ4g
        log: https://dps.report/txt6-20260416-200945_golem

  - name: Condi Willbender SC/P P/T
    profession: Willbender
    value:
      {
        "values2": { "Power": 2588, "Power2": 0, "Burning": 16.2, "Bleeding": 5.62, "Poisoned": 0, "Torment": 1.14, "Confusion": 0 }
      }
    credit:
      - author: Lyco
        url: https://www.youtube.com/watch?v=kH5282Lwmrw
        log: https://dps.report/gkj1-20260501-134125_golem

  - name: Condi Willbender Sword
    profession: Willbender
    value:
      {
        "values2": { "Power": 2871, "Power2": 0, "Burning": 14.05, "Bleeding": 0, "Poisoned": 0, "Torment": 0, "Confusion": 0 }
      }
    credit:
      - author: 'Support Hero'
        url: https://www.youtube.com/watch?v=1_GEZ8Wq2PM
        log: https://dps.report/W6No-20231004-182316_golem

  # 12 boons
  # viper glove boot ring ear ear back, rest grieving, flame legion, fishy
  # NO JADE BOT (in arc log, probably - seems bugged)
  - name: Condi Willbender GS
    profession: Willbender
    value:
      {
        "values2": { "Power": 3010, "Power2": 0, "Burning": 13.38, "Bleeding": 0, "Poisoned": 0, "Torment": 0, "Confusion": 0 }
      }
    credit:
      - author: '[CnD] DaedDee'
        url: https://www.youtube.com/watch?v=mCOEGlJkRJ0
        log: https://dps.report/z2Zl-20220316-172733_golem

  - name: Quickness Condi Firebrand P/T P/P
    profession: Firebrand
    value:
      {
        "values2": { "Power": 1687, "Power2": 0, "Burning": 18.3, "Bleeding": 7.65, "Poisoned": 0, "Torment": 0.18, "Confusion": 0 }
      }
    credit:
      - author: Lyco
        url: https://www.youtube.com/watch?v=j0oY6aNODvY
        log: https://dps.report/78wD-20250513-140024_golem

  - name: Condi Firebrand A/T P/P (Allies)
    profession: Firebrand
    value:
      {
        "values2": { "Power": 2095, "Power2": 0, "Burning": 15.97, "Bleeding": 12.33, "Poisoned": 0, "Torment": 0, "Confusion": 0 }
      }
    credit:
      - author: Chimera
        url: https://www.youtube.com/watch?v=D1U4EvqNkiw
        log: https://dps.report/hs0X-20260613-132856_golem

  - name: Condi Firebrand A/T
    profession: Firebrand
    value:
      {
        "values2": { "Power": 2219, "Power2": 0, "Burning": 13.98, "Bleeding": 14.64, "Poisoned": 0, "Torment": 0, "Confusion": 0 }
      }
    credit:
      - author: Iskarel
        url: https://www.youtube.com/watch?v=3K3fFUXvQKs
        log: https://dps.report/vPRV-20240706-013634_golem

  # - name: Condi Quickbrand (WT, Allies)
  #   profession: Firebrand
  #   value:
  #     {
  #       "values2": { "Power": 1397, "Power2": 0, "Burning": 14.23, "Bleeding": 6.07, "Poisoned": 0, "Torment": 0, "Confusion": 0 }
  #     }
  #   credit:
  #     - author: Iskarel
  #       url: https://www.youtube.com/watch?v=jv6BRBFb_H8
  #       log: https://dps.report/manG-20240324-193028_golem

  # - name: Condi Quickbrand (WT, No Allies)
  #   profession: Firebrand
  #   value:
  #     {
  #       "values2": { "Power": 1391, "Power2": 0, "Burning": 13.51, "Bleeding": 5.83, "Poisoned": 0, "Torment": 0, "Confusion": 0 }
  #     }
  #   credit:
  #     - author: Iskarel
  #       url: https://www.youtube.com/watch?v=jv6BRBFb_H8
  #       log: https://dps.report/OeKr-20240324-194950_golem

  # Solo log adjusted upwards to match with-allies dps (no log for the with allies bench)
  # - name: Condi Quickbrand (LL, Allies, Approx.)
  #   profession: Firebrand
  #   value:
  #     {
  #       "values2": { "Power": 2023, "Power2": 0, "Burning": 16.65, "Bleeding": 3.51, "Poisoned": 0, "Torment": 0, "Confusion": 0 }
  #     }
  #   credit:
  #     - author: 'Support Hero'
  #       url: https://www.youtube.com/watch?v=zGr5pn7jn2A
  #       log: https://dps.report/GP0v-20230228-174716_golem

  # - name: Condi Quickbrand (LL, No Allies)
  #   profession: Firebrand
  #   value:
  #     {
  #       "values2": { "Power": 2023, "Power2": 0, "Burning": 13.95, "Bleeding": 3.34, "Poisoned": 0, "Torment": 0, "Confusion": 0 }
  #     }
  #   credit:
  #     - author: 'Support Hero'
  #       url: https://www.youtube.com/watch?v=zGr5pn7jn2A
  #       log: https://dps.report/GP0v-20230228-174716_golem

  # - name: Hybrid FB (Virtues, no allies)
  #   profession: Firebrand
  #   value:
  #     {
  #       "values2": { "Power": 1942, "Power2": 0, "Burning": 12.1, "Bleeding": 3.0, "Poisoned": 0, "Torment": 0, "Confusion": 0 }
  #     }

  # +1.7 burning for no allies/with allies split on 5 page seems to hold up well

  - name: Hybrid FB Virtues
    profession: Firebrand
    value:
      {
        "values2": { "Power": 1864, "Power2": 0, "Burning": 13.8, "Bleeding": 3.0, "Poisoned": 0, "Torment": 0, "Confusion": 0 }
      }
    noCreditOkay: true

  - name: Hybrid FB (Honor, No Allies)
    profession: Firebrand
    value:
      {
        "values2": { "Power": 2203, "Power2": 0, "Burning": 9.05, "Bleeding": 16.22, "Poisoned": 0, "Torment": 0, "Confusion": 0 }
      }
    credit:
      - author: Ostro
        url: https://www.youtube.com/watch?v=JMOfyIn0A5g
        log: https://dps.report/nc8C-20230701-014927_golem

  - name: Hybrid FB (Honor, Allies)
    profession: Firebrand
    value:
      {
        "values2": { "Power": 2014, "Power2": 0, "Burning": 10.92, "Bleeding": 16.16, "Poisoned": 0, "Torment": 0, "Confusion": 0 }
      }
    credit:
      - author: Ostro
        url: https://www.youtube.com/watch?v=JMOfyIn0A5g
        log: https://dps.report/qV8u-20230701-014606_golem

  # https://www.youtube.com/watch?v=-OiH1BLuJpo
  # https://dps.report/QdzV-35062rwb_golem
  # RHS
  - name: Power Willbender Radiance
    profession: Willbender
    value:
      {
        "values2": { "Power": 3289, "Power2": 0, "Burning": 2.9, "Bleeding": 0, "Poisoned": 0, "Torment": 0, "Confusion": 0 }
      }
    noCreditOkay: true

  - name: Power Willbender Virtues
    profession: Willbender
    value:
      {
        "values2": { "Power": 4514, "Power2": 0, "Burning": 4.65, "Bleeding": 0, "Poisoned": 0, "Torment": 0, "Confusion": 0 }
      }
    credit:
      - author: Chimera
        url: https://www.youtube.com/watch?v=SQTfkFLTZcI
        log: https://dps.report/Ph2l-20260416-225356_golem

  # 12 boons, celefood toxiccrystal, 14%
  - name: Condi Alacrity Willbender
    profession: Willbender
    value:
      {
        "values2": { "Power": 2197, "Power2": 0, "Burning": 11.75, "Bleeding": 7.44, "Poisoned": 0, "Torment": 0, "Confusion": 0 }
      }
    credit:
      - author: Chimera
        url: https://www.youtube.com/watch?v=5CSKbomxWE8
        log: https://dps.report/RisE-20260503-150249_golem

  # https://www.youtube.com/watch?v=uPQfoQ0sUYU
  # https://www.youtube.com/watch?v=uPQfoQ0sUYU
  # 12 boons, thief accuracy, 14%
  - name: Power Alacrity Willbender
    profession: Willbender
    value:
      {
        "values2": { "Power": 4206, "Power2": 0, "Burning": 2.7, "Bleeding": 0, "Poisoned": 0, "Torment": 0, "Confusion": 0 }
      }
    credit:
      - author: Chimera
        log: https://dps.report/8wkf-20260414-194515_golem
        url: https://www.youtube.com/watch?v=yrouhR5gMac

  - name: Power Luminary SP/GS
    profession: Luminary
    value:
      {
        "values2": { "Power": 4738, "Power2": 0, "Burning": 0.21, "Bleeding": 0, "Poisoned": 0, "Torment": 0, "Confusion": 0 }
      }
    credit:
      - author: Kadenar
        url: https://www.youtube.com/watch?v=11iOIl41p7A
        log: https://dps.report/tA3V-20260604-173032_golem

  # Bers Bers Divi Bers Drag Bers Divi Divi Drag Bers Bers Drag Bers
  - name: Alacrity Power Luminary LB/GS
    profession: Luminary
    value:
      {
        "values2": { "Power": 5021, "Power2": 0, "Burning": 1.22, "Bleeding": 0, "Poisoned": 0, "Torment": 0, "Confusion": 0 }
      }
    credit:
      - author: Chimera
        url: https://www.youtube.com/watch?v=GRAyPUi6SPc
        log: https://dps.report/b9Jm-20251215-195108_golem

  - name: Power Weaver (BTTH, small)
    profession: Weaver
    value:
      {
        "values2": { "Power": 4013, "Power2": 0, "Burning": 5.87, "Bleeding": 3.55, "Poisoned": 0, "Torment": 0, "Confusion": 0 }
      }
    credit:
      - author: 'jkerkhoven'
        url: https://www.youtube.com/watch?v=--lsDK7NHgE
        log: https://dps.report/TNDD-20260415-003554_golem

  # sini helm
  - name: Condi Weaver P/D
    profession: Weaver
    value:
      {
        "values2": { "Power": 2063, "Power2": 0, "Burning": 8.94, "Bleeding": 33.85, "Poisoned": 0, "Torment": 0, "Confusion": 0 }
      }
    credit:
      - author: 'Ryan'
        url: https://www.youtube.com/watch?v=Ot5xuT0Xcyg
        log: https://dps.report/26i4-20260418-202046_golem

  # no jade bot
  - name: Condi Weaver Sword
    profession: Weaver
    value:
      {
        "values2": { "Power": 2626, "Power2": 0, "Burning": 11.78, "Bleeding": 14.92, "Poisoned": 0, "Torment": 0, "Confusion": 0 }
      }
    credit:
      - author: '[SC] Roul'
        url: https://www.youtube.com/watch?v=H5ZyMQln6hw
        log: https://dps.report/Bb0l-20210609-103359_golem

  # no jade bot
  - name: Condi Weaver (Dagger)
    profession: Weaver
    value:
      {
        "values2": { "Power": 2091, "Power2": 0, "Burning": 12.01, "Bleeding": 17.55, "Poisoned": 0, "Torment": 0, "Confusion": 0 }
      }
    credit:
      - author: 'Ryan'
        url: https://www.youtube.com/watch?v=5XgoudKAKRw
        log: https://dps.report/g1E9-20210609-022715_golem

  - name: Condi Weaver Staff (Large)
    profession: Weaver
    value:
      {
        "values2": { "Power": 3096, "Power2": 0, "Burning": 10.35, "Bleeding": 16.51, "Poisoned": 0, "Torment": 0, "Confusion": 0 }
      }
    credit:
      - author: 'Fennec'
        url: https://www.youtube.com/watch?v=4cj0BEcXCpc
        log: https://dps.report/5ShG-20230714-032530_golem

  # Without eles (distribution still comparable, lower rng)
  # sini helm
  - name: Condi Weaver Scepter
    profession: Weaver
    value:
      {
        "values2": { "Power": 2802, "Power2": 0, "Burning": 12.98, "Bleeding": 16.84, "Poisoned": 0, "Torment": 0.04, "Confusion": 0 }
      }
    credit:
      - author: Ryan
        url: https://www.youtube.com/watch?v=odkCQjns1HU
        log: https://dps.report/FtzK-20260416-203228_golem

  - name: Hybrid Weaver
    profession: Weaver
    value:
      {
        "values2": { "Power": 3328, "Power2": 0, "Burning": 11.76, "Bleeding": 1.88, "Poisoned": 0, "Torment": 0, "Confusion": 0 }
      }
    credit:
      - author: '[SC] Trace'
        url: https://www.youtube.com/watch?v=sU5-g4wBsgw
        log: https://dps.report/4kbg-20230312-075239_golem

  - name: Alacrity Condi Tempest Scepter
    profession: Tempest
    value:
      {
        "values2": { "Power": 2400, "Power2": 0, "Burning": 11.49, "Bleeding": 17.14, "Poisoned": 0, "Torment": 0.05, "Confusion": 0 }
      }
    credit:
      - author: '[NA] Crone'
        url: https://www.youtube.com/watch?v=ID-UFSX2zKw
        log: https://dps.report/DLQz-20260426-122231_golem

  - name: Alacrity Fire Tempest Condi
    profession: Tempest
    value:
      {
        "values2": { "Power": 2754, "Power2": 0, "Burning": 15.3, "Bleeding": 0.58, "Poisoned": 0, "Torment": 0, "Confusion": 0 }
      }
    credit:
      - author: 'Kadenar'
        url: https://www.youtube.com/watch?v=RIFOm4KSkRY
        log: https://dps.report/idzi-20260504-143508_golem

  - name: Condi Tempest Pistol
    profession: Tempest
    value:
      {
        "values2": { "Power": 2206, "Power2": 0, "Burning": 10.1, "Bleeding": 26.82, "Poisoned": 0, "Torment": 0.05, "Confusion": 0 }
      }
    credit:
      - author: '[NA] Crone'
        url: https://www.youtube.com/watch?v=_lFQeVzF1o4
        log: https://dps.report/B38a-20260414-224425_golem

  - name: Condi Tempest Hammer
    profession: Tempest
    value:
      {
        "values2": { "Power": 2506, "Power2": 0, "Burning": 10.73, "Bleeding": 16.73, "Poisoned": 0, "Torment": 0, "Confusion": 0 }
      }
    credit:
      - author: 'Dánmander'
        url: https://www.youtube.com/watch?v=UI_DqbbBhWg
        log: https://dps.report/JJvS-20231203-145912_golem

  - name: Alacrity Fire Tempest Inferno
    profession: Tempest
    value:
      {
        "values2": { "Power": 2866, "Power2": 0, "Burning": 14.48, "Bleeding": 0.38, "Poisoned": 0, "Torment": 0, "Confusion": 0 }
      }
    credit:
      - author: '[NA] Crone'
        url: https://www.youtube.com/watch?v=50-VmnennEs
        log: https://dps.report/0kW0-20251120-143549_golem

  - name: Power Tempest Inferno
    profession: Tempest
    value:
      {
        "values2": { "Power": 3656, "Power2": 0, "Burning": 10.33, "Bleeding": 3.93, "Poisoned": 0, "Torment": 0, "Confusion": 0 }
      }
    credit:
      - author: Kadenar
        url: https://www.youtube.com/watch?v=_YU4PyjNYOo
        log: https://dps.report/j7LY-20260414-172451_golem

  # currently exact copy of alacrity fire tempest (i.e. incorrectly ignoring transcendent tempest reduced overload cooldown)
  - name: Fire-only Tempest (Approx.)
    profession: Tempest
    value:
      {
        "values2": { "Power": 2866, "Power2": 0, "Burning": 14.48, "Bleeding": 0.38, "Poisoned": 0, "Torment": 0, "Confusion": 0 }
      }
    noCreditOkay: true

  - name: Power Tempest Scepter
    profession: Tempest
    value:
      {
        "values2": { "Power": 4549, "Power2": 0, "Burning": 3.86, "Bleeding": 3.1, "Poisoned": 0, "Torment": 0, "Confusion": 0 }
      }
    credit:
      - author: '[NA] Crone'
        url: https://www.youtube.com/watch?v=uyCFtPEndMU
        log: https://dps.report/aDHa-20260417-044805_golem

  - name: Alacrity Power Tempest Sword
    profession: Tempest
    value:
      {
        "values2": { "Power": 4186, "Power2": 0, "Burning": 3.59, "Bleeding": 3.3, "Poisoned": 0, "Torment": 0, "Confusion": 0 }
      }
    credit:
      - author: 'Black'
        url: https://www.youtube.com/watch?v=QWBSK1rk1JM
        log: https://dps.report/4oEj-20260420-081807_golem

  - name: Alacrity Power Tempest Hammer
    profession: Tempest
    value:
      {
        "values2": { "Power": 3792, "Power2": 0, "Burning": 3.6, "Bleeding": 4.29, "Poisoned": 0, "Torment": 0, "Confusion": 0 }
      }
    credit:
      - author: 'Black'
        url: https://www.youtube.com/watch?v=ZhhoRrW22Ks
        log: https://dps.report/L6zb-20250313-171138_golem

  - name: Power Catalyst Scepter Inferno
    profession: Catalyst
    value:
      {
        "values2": { "Power": 3629, "Power2": 0, "Burning": 7.19, "Bleeding": 6.2, "Poisoned": 0.43, "Torment": 0, "Confusion": 0 }
      }
    credit:
      - author: 'Kadenar'
        url: https://www.youtube.com/watch?v=1qiTvpzolpg
        log: https://dps.report/Kgu5-20260504-153710_golem

  - name: Quickness Power Catalyst Scepter Inferno
    profession: Catalyst
    value:
      {
        "values2": { "Power": 3909, "Power2": 0, "Burning": 7.33, "Bleeding": 6.21, "Poisoned": 0.41, "Torment": 0, "Confusion": 0 }
      }
    credit:
      - author: 'EDLR'
        url: https://www.youtube.com/watch?v=mABV6MGwKaE
        log: https://dps.report/6dTi-20251124-124151_golem

  - name: Quickness Power Catalyst Scepter PF
    profession: Catalyst
    value:
      {
        "values2": { "Power": 3813, "Power2": 0, "Burning": 6.2, "Bleeding": 5.62, "Poisoned": 0.14, "Torment": 0, "Confusion": 0 }
      }
    credit:
      - author: EDLR
        url: https://www.youtube.com/watch?v=t5nW5ZXOLEY
        log: https://dps.report/63Dx-20260416-134815_golem

  - name: Power Catalyst Scepter PF
    profession: Catalyst
    value:
      {
        "values2": { "Power": 3769, "Power2": 0, "Burning": 6.25, "Bleeding": 6.05, "Poisoned": 0.06, "Torment": 0, "Confusion": 0 }
      }
    credit:
      - author: Kadenar
        url: https://www.youtube.com/watch?v=BFGepGmiC_M
        log: https://dps.report/aAgi-20260414-165732_golem

  # quickness log, distribution works for both
  - name: Condi Catalyst P/D
    profession: Catalyst
    value:
      {
        "values2": { "Power": 2380, "Power2": 0, "Burning": 8.33, "Bleeding": 23.09, "Poisoned": 0.15, "Torment": 0, "Confusion": 0 }
      }
    credit:
      - author: Maragon
        url: https://www.youtube.com/watch?v=NQorza2BJZg
        log: https://dps.report/wJsO-20260416-231016_golem

  - name: Condi Quickness Catalyst P/W
    profession: Catalyst
    value:
      {
        "values2": { "Power": 1989, "Power2": 0, "Burning": 9.03, "Bleeding": 24.59, "Poisoned": 0.02, "Torment": 0.05, "Confusion": 0 }
      }
    credit:
      - author: Kadenar
        url: https://www.youtube.com/watch?v=gLFJNOtU4yg
        log: https://dps.report/CO8r-20260504-165413_golem

  - name: Fire SE Evoker Inferno
    profession: Evoker
    value:
      {
        "values2": { "Power": 2883, "Power2": 0, "Burning": 16.04, "Bleeding": 0, "Poisoned": 0, "Torment": 0, "Confusion": 0 }
      }
    credit:
      - author: Kadenar
        url: https://www.youtube.com/watch?v=yKLioMzZm_I
        log: https://dps.report/TCOY-20251213-151502_golem

  # above log + burning rage + persisting flames
  # add 0.1 conflagration/sec * 8 burning/sunspot
  # add 0.1 flamewall/sec * 2 extra flamewall ticks * 2.5 burning
  # add 0.1 flamewall/sec * 2 extra flamewall ticks * 0.1 coefficient * 690.5 strength
  # 2883+.1*2*.1*690.5
  # 16.04+.1*8+.1*2*2.5
  - name: Fire SE Evoker Condi
    profession: Evoker
    value:
      {
        "values2": { "Power": 2991, "Power2": 0, "Burning": 18.6, "Bleeding": 0, "Poisoned": 0, "Torment": 0.04, "Confusion": 0 }
      }
    credit:
      - author: Kadenar
        url: https://www.youtube.com/watch?v=O_oAtMZSIP8
        log: https://dps.report/zPEa-20260421-193615_golem

  - name: Quickness Fire SE Evoker Condi
    profession: Evoker
    value:
      {
        "values2": { "Power": 3005, "Power2": 0, "Burning": 18.81, "Bleeding": 0, "Poisoned": 0, "Torment": 0, "Confusion": 0 }
      }
    credit:
      - author: Kadenar
        url: https://www.youtube.com/watch?v=CReb1PpXxm8
        log: https://dps.report/2aDW-20260421-233936_golem

  # above log + ~5.5x earth signet - 4x firestorm (6 is a guess, this is approximate anyway)
  # subtract 0.49 firestorm ticks/sec * 0.5 coefficient * 690.5 strength
  # subtract 0.49 firestorm ticks/sec * 0.5 coefficient * 2 burning/tick
  # add 0.06 signet casts/sec * 36 bleed
  # add 0.06 signet casts/sec * 30 bleed
  # add 0.06 signet casts/sec * 0.5 coefficient * 690.5 strength
  # 2897-0.49*0.5*690.5+0.06*0.5*690.5
  # 17.34-.49*.5*2
  # 0.06 * 66
  - name: Fire SE Evoker Trailblazer (Approx.)
    profession: Evoker
    value:
      {
        "values2": { "Power": 2749, "Power2": 0, "Burning": 16.85, "Bleeding": 3.96, "Poisoned": 0, "Torment": 0, "Confusion": 0 }
      }
    credit:
      - author: Kadenar
        url: https://www.youtube.com/watch?v=yKLioMzZm_I
        log: https://dps.report/TCOY-20251213-151502_golem

  - name: Power Evoker Hare PF
    profession: Evoker
    value:
      {
        "values2": { "Power": 4156, "Power2": 0, "Burning": 6.87, "Bleeding": 7.42, "Poisoned": 0, "Torment": 0, "Confusion": 0 }
      }
    credit:
      - author: Kadenar
        url: https://www.youtube.com/watch?v=GB27f1n4ZZ0
        log: https://dps.report/R5M5-20260414-134009_golem

  - name: Power Evoker Hare Inferno
    profession: Evoker
    value:
      {
        "values2": { "Power": 4194, "Power2": 0, "Burning": 8.44, "Bleeding": 6.94, "Poisoned": 0, "Torment": 0, "Confusion": 0 }
      }
    credit:
      - author: Kadenar
        url: https://www.youtube.com/watch?v=c6OE5O4a0CI
        log: https://dps.report/5naZ-20251212-164914_golem

  - name: Alacrity Power Evoker Toad
    profession: Evoker
    value:
      {
        "values2": { "Power": 4371, "Power2": 0, "Burning": 7.22, "Bleeding": 11.37, "Poisoned": 0, "Torment": 0, "Confusion": 0 }
      }
    credit:
      - author: Kadenar
        url: https://www.youtube.com/watch?v=izeVnL4Gobs
        log: https://dps.report/3LQO-20260422-135335_golem

  - name: Condi Evoker P/D
    profession: Evoker
    value:
      {
        "values2": { "Power": 2689, "Power2": 0, "Burning": 13.42, "Bleeding": 22.61, "Poisoned": 0, "Torment": 0, "Confusion": 0 }
      }
    credit:
      - author: Limelight
        url: https://www.youtube.com/watch?v=a0G3lrJoHME
        log: https://dps.report/3LQO-20260422-135335_golem

  - name: Fire-only Weaver
    profession: Weaver
    value:
      {
        "values2": { "Power": 2553, "Power2": 0, "Burning": 14.56, "Bleeding": 0, "Poisoned": 0, "Torment": 0, "Confusion": 0 }
      }
    credit:
      - author: Kadenar
        url: https://www.youtube.com/watch?v=pJ3fipl1rNU
        log: https://dps.report/ezTN-20251223-120339_golem

  - name: Alacrity Power Renegade
    profession: Renegade
    value:
      {
        "values2": { "Power": 3887, "Power2": 0, "Burning": 0.73, "Bleeding": 0, "Poisoned": 0, "Torment": 1.61, "Confusion": 0 }
      }
    credit:
      - author: Shavy
        url: https://www.youtube.com/watch?v=e3HyMQDFQnI
        log: https://dps.report/3hSA-20250215-132703_golem

  - name: Alacrity Condi Renegade SB M/A
    profession: Renegade
    value:
      {
        "values2": { "Power": 2139, "Power2": 0, "Burning": 3.97, "Bleeding": 12.36, "Poisoned": 4.42, "Torment": 17.24, "Confusion": 0 }
      }
    credit:
      - author: Umbra
        url: https://www.youtube.com/watch?v=J_1pVfkTvHo
        log: https://dps.report/8VfB-20240706-155741_golem

  - name: Condi Renegade Spear M/A (No Allies)
    profession: Renegade
    value:
      {
        "values2": { "Power": 2299, "Power2": 0, "Burning": 3.17, "Bleeding": 6.06, "Poisoned": 6.09, "Torment": 23.44, "Confusion": 0 }
      }
    credit:
      - author: Jul Nine
        url: https://www.youtube.com/watch?v=sBeD0k4ntgU
        log: https://dps.report/BOMb-20250427-142254_golem

  # add razorclaw casts to simulate allies
  # 4 players * 4 stacks * 3s bleed * 5 cast/93s = 2.58 bleed
  - name: Condi Renegade Spear M/A (Allies)
    profession: Renegade
    value:
      {
        "values2": { "Power": 2299, "Power2": 0, "Burning": 3.17, "Bleeding": 8.64, "Poisoned": 6.09, "Torment": 23.44, "Confusion": 0 }
      }
    credit:
      - author: Jul Nine
        url: https://www.youtube.com/watch?v=sBeD0k4ntgU
        log: https://dps.report/BOMb-20250427-142254_golem

  - name: Condi Renegade Spear Only (No Allies)
    profession: Renegade
    value:
      {
        "values2": { "Power": 3047, "Power2": 0, "Burning": 2.17, "Bleeding": 4.78, "Poisoned": 4.57, "Torment": 24.79, "Confusion": 0 }
      }
    credit:
      - author: Jul Nine
        url: https://www.youtube.com/watch?v=GjAxJJznZCI
        log: https://dps.report/pSKu-20250424-235607_golem

  # add razorclaw casts to simulate allies
  # 4 players * 4 stacks * 3s bleed * 5 cast/92s = 2.6 bleed
  - name: Condi Renegade Spear Only (Allies)
    profession: Renegade
    value:
      {
        "values2": { "Power": 3047, "Power2": 0, "Burning": 2.17, "Bleeding": 7.38, "Poisoned": 4.57, "Torment": 24.79, "Confusion": 0 }
      }
    credit:
      - author: Jul Nine
        url: https://www.youtube.com/watch?v=GjAxJJznZCI
        log: https://dps.report/pSKu-20250424-235607_golem

  - name: Alacrity Condi Renegade Spear M/A (No Allies)
    profession: Renegade
    value:
      {
        "values2": { "Power": 2182, "Power2": 0, "Burning": 3.03, "Bleeding": 6.02, "Poisoned": 5.55, "Torment": 23.62, "Confusion": 0 }
      }
    credit:
      - author: Jul Nine
        url: https://www.youtube.com/watch?v=6hCzxKcmoQ8
        log: https://dps.report/aZsY-20241029-155240_golem

  # add razorclaw casts to simulate allies
  # 4 players * 4 stacks * 3s bleed * 6 cast/107s = 2.69 bleed
  - name: Alacrity Condi Renegade Spear M/A (Allies)
    profession: Renegade
    value:
      {
        "values2": { "Power": 2182, "Power2": 0, "Burning": 3.03, "Bleeding": 8.71, "Poisoned": 5.55, "Torment": 23.62, "Confusion": 0 }
      }
    credit:
      - author: Jul Nine
        url: https://www.youtube.com/watch?v=6hCzxKcmoQ8
        log: https://dps.report/aZsY-20241029-155240_golem

  - name: Condi Alac Invocation (no allies)
    profession: Renegade
    value:
      {
        "values2": { "Power": 1903, "Power2": 0, "Burning": 4.14, "Bleeding": 9.37, "Poisoned": 4, "Torment": 16.09, "Confusion": 0 }
      }
    credit:
      - author: Umbra
        url: https://www.youtube.com/watch?v=uCI1Xu63SmM
        log: https://dps.report/ervZ-20231003-013459_golem

  # add razorclaw casts every 20sec to simulate allies
  # 4 players * 10 pulses * 2 seconds / 20 sec = 4.00 avg bleed
  - name: Condi Renegade SB Devastation
    profession: Renegade
    value:
      {
        "values2": { "Power": 2092, "Power2": 0, "Burning": 4.21, "Bleeding": 14.13, "Poisoned": 2.23, "Torment": 16.34, "Confusion": 0 }
      }
    credit:
      - author: '[Inn] Xorxy'
        url: https://www.youtube.com/watch?v=PvE-x43QrHo
        log: https://dps.report/kByf-20220314-131547_golem

  # AP, full viper, asparagus food
  - name: Condi Renegade SB Devastation (no allies)
    profession: Renegade
    value:
      {
        "values2": { "Power": 2092, "Power2": 0, "Burning": 4.21, "Bleeding": 10.13, "Poisoned": 2.23, "Torment": 16.34, "Confusion": 0 }
      }
    credit:
      - author: '[Inn] Xorxy'
        url: https://www.youtube.com/watch?v=PvE-x43QrHo
        log: https://dps.report/kByf-20220314-131547_golem

  # add razorclaw casts every 20sec to simulate allies
  # 4 players * 10 pulses * 2 seconds / 20 sec = 4.00 avg bleed
  - name: Condi Renegade SB Invocation
    profession: Renegade
    value:
      {
        "values2": { "Power": 2011, "Power2": 0, "Burning": 4.48, "Bleeding": 14.48, "Poisoned": 4.07, "Torment": 18.32, "Confusion": 0 }
      }
    credit:
      - author: '[InS] Laoshi'
        url: https://www.youtube.com/watch?v=9wOyiE2Bvts
        log: https://dps.report/EeYd-20221008-182313_golem

  - name: Condi Renegade SB Invocation (no allies)
    profession: Renegade
    value:
      {
        "values2": { "Power": 2011, "Power2": 0, "Burning": 4.48, "Bleeding": 10.48, "Poisoned": 4.07, "Torment": 18.32, "Confusion": 0 }
      }
    credit:
      - author: '[InS] Laoshi'
        url: https://www.youtube.com/watch?v=9wOyiE2Bvts
        log: https://dps.report/EeYd-20221008-182313_golem

  # not including ally lifesteal
  # todo: convert 122dps to self lifesteal
  - name: Power Quickness Herald
    profession: Herald
    value:
      {
        "values2": { "Power": 3056, "Power2": 0, "Burning": 0.72, "Bleeding": 0, "Poisoned": 0, "Torment": 0, "Confusion": 0 }
      }
    credit:
      - author: Umbra
        url: https://www.youtube.com/watch?v=uvMQy0C9fo0
        log: https://dps.report/gpDG-20231003-204833_golem

  # not including ally lifesteal
  # todo: convert 268dps to self lifesteal
  - name: Power Herald FP
    profession: Herald
    value:
      {
        "values2": { "Power": 2838, "Power2": 0, "Burning": 1.43, "Bleeding": 0, "Poisoned": 0, "Torment": 0, "Confusion": 0 }
      }
    credit:
      - author: 'Umbra'
        url: https://www.youtube.com/watch?v=DJtoo1abq9U
        log: https://dps.report/rW1Q-20221202-011416_golem

  - name: Condi Quickness Herald Spear M/A
    profession: Herald
    value:
      {
        "values2": { "Power": 2074, "Power2": 0, "Burning": 4.31, "Bleeding": 3.57, "Poisoned": 5.91, "Torment": 19.13, "Confusion": 0 }
      }
    credit:
      - author: '[CRS] Rainer'
        url: https://www.youtube.com/watch?v=0_9xfLqznd0
        log: https://dps.report/ErCv-20250216-134453_golem

  - name: Condi Quickness Herald Spear
    profession: Herald
    value:
      {
        "values2": { "Power": 2370, "Power2": 0, "Burning": 2.59, "Bleeding": 3.33, "Poisoned": 5.13, "Torment": 20.63, "Confusion": 0 }
      }
    credit:
      - author: Kartky
        url: https://www.youtube.com/watch?v=97pLrywGOfQ
        log: https://dps.report/DJD7-20250212-150821_golem

  - name: Condi Quickness Herald SB M/A
    profession: Herald
    value:
      {
        "values2": { "Power": 2194, "Power2": 0, "Burning": 4.95, "Bleeding": 6.53, "Poisoned": 4.55, "Torment": 15.83, "Confusion": 0 }
      }
    credit:
      - author: Kadenar
        url: https://www.youtube.com/watch?v=4YgZYgLOJXc
        log: https://dps.report/e0xk-20250216-203504_golem

  # force air force air
  - name: DPS Vindicator
    profession: Vindicator
    value:
      {
        "values2": { "Power": 3673, "Power2": 0, "Burning": 0, "Bleeding": 0, "Poisoned": 0, "Torment": 2.96, "Confusion": 0 }
      }
    credit:
      - author: beng / L3m0n
        url: https://www.youtube.com/watch?v=tu56q1WZlOU
        log: https://dps.report/RlrB-20240222-163421_golem

  - name: Condition Conduit
    profession: Conduit
    value:
      {
        "values2": { "Power": 2507, "Power2": 0, "Burning": 7.69, "Bleeding": 7.7, "Poisoned": 5.08, "Torment": 28.66, "Confusion": 6.07 }
      }
    credit:
      - author: beng / L3m0n
        url: https://www.youtube.com/watch?v=Lf2R-zkQjDI
        log: https://dps.report/Iac9-20251210-122341_golem

  - name: Condition Conduit SOTM
    profession: Conduit
    value:
      {
        "values2": { "Power": 2463, "Power2": 0, "Burning": 7.81, "Bleeding": 7.7, "Poisoned": 5.66, "Torment": 26.34, "Confusion": 6.3 }
      }
    credit:
      - author: Jul Nine
        url: https://www.youtube.com/watch?v=Z6Mk_QZn1xA
        log: https://dps.report/U5iP-20251218-232219_golem

  - name: Power Conduit S/S PW Thief
    profession: Conduit
    value:
      {
        "values2": { "Power": 3866, "Power2": 0, "Burning": 0, "Bleeding": 4.3, "Poisoned": 0, "Torment": 0, "Confusion": 0 }
      }
    credit:
      - author: Yurugani
        url: https://www.youtube.com/watch?v=0DH0NXcqUrM
        log: https://dps.report/BWYo-20251211-175030_golem

  # bursting expertisefood
  - name: Quickness Condi Untamed
    profession: Untamed
    value:
      {
        "values2": { "Power": 2156, "Power2": 0, "Burning": 3.95, "Bleeding": 19.25, "Poisoned": 12.66, "Torment": 0, "Confusion": 0 }
      }
    credit:
      - author: Chimera
        url: https://www.youtube.com/watch?v=mJDLeT-TEYw
        log: https://dps.report/19d1-20260414-205010_golem

  - name: Power Soulbeast
    profession: Soulbeast
    value:
      {
        "values2": { "Power": 3614, "Power2": 0, "Burning": 0, "Bleeding": 1.57, "Poisoned": 0.48, "Torment": 0, "Confusion": 0 }
      }
    credit:
      - author: "DingoUndSo"
        url: https://www.youtube.com/watch?v=fH9eotFn7v4
        log: https://dps.report/uIbg-20260415-225033_golem

  # https://www.youtube.com/watch?v=-bipnEirEGA
  # https://dps.report/JBAr-20210620-110933_golem
  # no jade bot, rendang
  #
  # 698 dps from OWP (which is ~234 power coefficient)
  # 57 hits in 110s, 0.518 hit/s
  # no sic em coefficient: .63 * 690.5 = 435.0 * hitrate
  # 0.518 hit/s * 435.0 = 225
  # (does not match well because of higher than average TaV on OWP, but whatever)
  - name: Condi Slb (D/T SB)
    profession: Soulbeast
    value:
      {
        "values2": { "Power": 1366, "Power2": 0, "Burning": 2.42, "Bleeding": 21.7, "Poisoned": 16.26, "Torment": 0, "Confusion": 0 }
      }
    credit:
      - author: Snow Crows

  # https://www.youtube.com/watch?v=rr-gJuN3ECA
  # https://dps.report/zzE6-20210514-155136_golem
  # no jade bot, rendang
  #
  # 644 dps from OWP (which is ~216 power coefficient)
  # 56 hits in 110s, 0.51 hit/s
  # no sic em coefficient: .63 * 690.5 = 435.0 * hitrate
  # 0.51 hit/s * 435.0 = 222
  # (does not match well because of higher than average TaV on OWP, but whatever)
  - name: Condi Slb (D/T A/D)
    profession: Soulbeast
    value:
      {
        "values2": { "Power": 1442, "Power2": 0, "Burning": 3.54, "Bleeding": 19.95, "Poisoned": 13.86, "Torment": 0, "Confusion": 0 }
      }
    credit:
      - author: Snow Crows

  # Approximated with full solo hits/cast of vulture stance (36)
  # Note: solo number, not with allies
  - name: Condi Slb D/D SB
    profession: Soulbeast
    value:
      {
        "values2": { "Power": 1770, "Power2": 0, "Burning": 0.11, "Bleeding": 18.74, "Poisoned": 16.94, "Torment": 0.17, "Confusion": 0 }
      }
    credit:
      - author: Pip
        url: https://www.youtube.com/watch?v=vVg2UaZAFLs
        log: https://dps.report/pltF-20260414-175142_golem

  # - name: Hybrid Slb OS (A/T D/A)
  #   profession: Soulbeast
  #   value:
  #     {
  #       "values2": { "Power": 2382, "Power2": 0, "Burning": 2.25, "Bleeding": 23.11, "Poisoned": 3.14, "Torment": 0.05, "Confusion": 0 }
  #     }
  #   credit:
  #     - author: Umbra
  #       url: https://www.youtube.com/watch?v=SgCNpLWO-KA
  #       log: https://dps.report/qHdT-20220712-170120_golem

  - name: Hybrid Slb A/T D/A
    profession: Soulbeast
    value:
      {
        "values2": { "Power": 2531, "Power2": 0, "Burning": 2.12, "Bleeding": 19.45, "Poisoned": 2.56, "Torment": 0.04, "Confusion": 0 }
      }
    credit:
      - author: Pip
        url: https://www.youtube.com/watch?v=JuZyk0XhypM
        log: https://dps.report/aZbB-20230628-221125_golem

  # im sorry
  # koi cake
  # - name: Pure Shortbow Slb BM
  #   profession: Soulbeast
  #   value:
  #     {
  #       "values2": { "Power": 1661, "Power2": 0, "Burning": 0.54, "Bleeding": 25.48, "Poisoned": 11.45, "Torment": 0, "Confusion": 0 }
  #     }
  #   credit:
  #     - author: 'Talonflame'
  #       url: https://www.youtube.com/watch?v=70F-uEOb-Bg
  #       log: https://dps.report/Oq8d-20210609-135312_golem

  - name: Condi Druid LOYF
    profession: Druid
    value:
      {
        "values2": { "Power": 1873, "Power2": 0, "Burning": 5.5, "Bleeding": 26.69, "Poisoned": 16.66, "Torment": 0.01, "Confusion": 0 }
      }
    credit:
      - author: Trufla
        url: https://www.youtube.com/watch?v=1LzciIUuctQ
        log: https://dps.report/qzQD-20260418-172502_golem

  - name: Quickness Power Untamed HA S/A NM
    profession: Untamed
    value:
      {
        "values2": { "Power": 3492, "Power2": 0, "Burning": 0, "Bleeding": 0.09, "Poisoned": 2.12, "Torment": 0, "Confusion": 0 }
      }
    credit:
      - author: Chimera
        url: https://www.youtube.com/watch?v=CY44yXR14uk
        log: https://dps.report/kIwI-20250519-113617_golem

  - name: Power Untamed HA S/A
    profession: Untamed
    value:
      {
        "values2": { "Power": 3481, "Power2": 0, "Burning": 0, "Bleeding": 0, "Poisoned": 2.81, "Torment": 0, "Confusion": 0 }
      }
    credit:
      - author: Trufla
        url: https://www.youtube.com/watch?v=WSq2wVfhnrQ
        log: https://dps.report/ZIQz-20260501-143444_golem

  - name: Power Galeshot
    profession: Galeshot
    value:
      {
        "values2": { "Power": 4097, "Power2": 0, "Burning": 0, "Bleeding": 6.29, "Poisoned": 1.42, "Torment": 0, "Confusion": 0.54 }
      }
    credit:
      - author: Trufla
        url: https://www.youtube.com/watch?v=Fe5nyzF9WMo
        log: https://dps.report/w2Ie-20260420-170700_golem


  - name: Power Holo PBM
    profession: Holosmith
    value:
      {
        "values2": { "Power": 3974, "Power2": 0, "Burning": 5.27, "Bleeding": 5.1, "Poisoned": 2.95, "Torment": 0, "Confusion": 0 }
      }
    credit:
      - author: '[SC] Fallen'
        url: https://www.youtube.com/watch?v=v6AARzsY6iA
        log: https://dps.report/P7Qz-20231003-143924_golem

  - name: Power Holo ECSU
    profession: Holosmith
    value:
      {
        "values2": { "Power": 3890, "Power2": 0, "Burning": 5.41, "Bleeding": 9.82, "Poisoned": 2.39, "Torment": 0, "Confusion": 0 }
      }
    credit:
      - author: Cody
        url: https://www.youtube.com/watch?v=F6A09H0W0B4
        log: https://dps.report/j9eE-20240324-171603_golem

  - name: Condi Holo
    profession: Holosmith
    value:
      {
        "values2": { "Power": 3451, "Power2": 0, "Burning": 16.55, "Bleeding": 7.81, "Poisoned": 3.76, "Torment": 0, "Confusion": 2.58 }
      }
    credit:
      - author: beng / L3m0n
        url: https://www.youtube.com/watch?v=DWeRHpxkNpk
        log: https://dps.report/FgwI-20250701-134540_golem

  # has lifesteal food; subtracy 127 power dps
  # mech does burning (???) - import tool breaks
  - name: Power Alacrity Mechanist (inaccurate)
    profession: Mechanist
    value:
      {
        "values2": { "Power": 2745, "Power2": 0, "Burning": 4.38, "Bleeding": 5.45, "Poisoned": 3.45, "Torment": 0, "Confusion": 10.45 }
      }
    credit:
      - author: '[CnD] Xyonon'
        url: https://www.youtube.com/watch?v=xjCNAyzVmQM
        log: https://dps.report/PRXW-20220416-225625_golem

  - name: Condi Mechanist J-Drive (approx.)
    profession: Mechanist
    value:
      {
        "values2": { "Power": 3622, "Power2": 0, "Burning": 6.17, "Bleeding": 18.34, "Poisoned": 9.03, "Torment": 0, "Confusion": 3.83 }
      }
    credit:
      - author: '[NA] Crone'
        url: https://www.youtube.com/watch?v=o3cmPNH620s
        log: https://dps.report/Vh6i-20240220-101735_golem

  # icicle
  - name: Condi Mechanist Jade Dynamo Pistol (approx.)
    profession: Mechanist
    value:
      {
        "values2": { "Power": 3566, "Power2": 0, "Burning": 7.42, "Bleeding": 17.54, "Poisoned": 10.05, "Torment": 0, "Confusion": 9.18 }
      }
    credit:
      - author: '[CnD] Lunar'
        url: https://www.youtube.com/watch?v=URNB2JkmtG0
        log: https://dps.report/8GVP-20220308-005706_golem

  - name: Condi Alac Mechanist (inaccurate)
    profession: Mechanist
    value:
      {
        "values2": { "Power": 3124, "Power2": 0, "Burning": 8.81, "Bleeding": 9.98, "Poisoned": 9.25, "Torment": 0, "Confusion": 5.02 }
      }
    credit:
      - author: '[CnD] Xyonon'
        url: https://www.youtube.com/watch?v=dMdGeWnKaRA
        log: https://dps.report/Hjvb-20220312-192709_golem

  - name: Power Scrapper
    profession: Scrapper
    value:
      {
        "values2": { "Power": 3662, "Power2": 0, "Burning": 0, "Bleeding": 4.98, "Poisoned": 4.78, "Torment": 0, "Confusion": 0 }
      }
    credit:
      - author: 'beng / L3m0n'
        url: https://www.youtube.com/watch?v=D_rBzRClNFU
        log: https://dps.report/VMeG-20240703-153531_golem

  - name: Quickness Condi Scrapper Steamshrieker
    profession: Scrapper
    value:
      {
        "values2": { "Power": 2603, "Power2": 0, "Burning": 11.78, "Bleeding": 9.12, "Poisoned": 4.76, "Torment": 0, "Confusion": 2.76 }
      }
    credit:
      - author: 'mayo [cA]'
        url: https://www.youtube.com/watch?v=Kihy8XZpRaw
        log: https://dps.report/sFjF-20251014-124731_golem

  # dragon legs+back
  - name: Alacrity Power Amalgam
    profession: Amalgam
    value:
      {
        "values2": { "Power": 3710, "Power2": 0, "Burning": 1.41, "Bleeding": 9.45, "Poisoned": 4.3, "Torment": 0, "Confusion": 2.94 }
      }
    credit:
      - author: '[NA] Crone'
        url: https://www.youtube.com/watch?v=KTEj3KhQ34c
        log: https://dps.report/BMF2-20251209-140418_golem

  - name: Alacrity Condi Amalgam 2 Kit
    profession: Amalgam
    value:
      {
        "values2": { "Power": 3024, "Power2": 0, "Burning": 11.77, "Bleeding": 13.59, "Poisoned": 7.38, "Torment": 0, "Confusion": 0 }
      }
    credit:
      - author: beng / L3m0n
        url: https://www.youtube.com/watch?v=6ee2rOfIyPU
        log: https://dps.report/aUmU-20251215-143447_golem

  - name: Alacrity Condi Amalgam 4 Kit
    profession: Amalgam
    value:
      {
        "values2": { "Power": 3102, "Power2": 0, "Burning": 11.96, "Bleeding": 13.3, "Poisoned": 6.11, "Torment": 0, "Confusion": 2.71 }
      }
    credit:
      - author: '[LN] Toilet'
        url: https://www.youtube.com/watch?v=tu_oEfBb8fI
        log: https://dps.report/WS8e-20251214-114850_golem

  - name: Power Chrono DT Spear
    profession: Chronomancer
    value:
      {
        "values2": { "Power": 3224, "Power2": 1120, "Burning": 0, "Bleeding": 1.45, "Poisoned": 0, "Torment": 0, "Confusion": 1.02 }
      }
    credit:
      - author: Cemox
        url: https://www.youtube.com/watch?v=lVrvBuizuF8
        log: https://dps.report/oRIi-20250627-124455_golem

  - name: Power Chrono IA GS
    profession: Chronomancer
    value:
      {
        "values2": { "Power": 3541, "Power2": 1419, "Burning": 0, "Bleeding": 0, "Poisoned": 0, "Torment": 0, "Confusion": 0.93 }
      }
    credit:
      - author: Cemox
        url: https://www.youtube.com/watch?v=QumcjR3f3JU
        log: https://dps.report/mV8B-20231003-224244_golem

  # https://discord.com/channels/380901000200060929/380903536424386560/1387195635517624513
  - name: Power Chrono IA Spear
    profession: Chronomancer
    value:
      {
        "values2": { "Power": 3484, "Power2": 1426, "Burning": 0, "Bleeding": 0, "Poisoned": 0, "Torment": 0, "Confusion": 1.36 }
      }
    credit:
      - author: Cemox
        url: https://dps.report/uDWQ-20250624-184443_golem
        log: https://dps.report/uDWQ-20250624-184443_golem

  - name: Boon Power Chrono DT Spear
    profession: Chronomancer
    value:
      {
        "values2": { "Power": 3418, "Power2": 955, "Burning": 0, "Bleeding": 1.09, "Poisoned": 0, "Torment": 0, "Confusion": 0.85 }
      }
    credit:
      - author: Cemox
        url: https://www.youtube.com/watch?v=36ifK9aG4VM
        log: https://dps.report/WtFG-20250627-141944_golem

  # https://discord.com/channels/380901000200060929/380903536424386560/1387195635517624513
  - name: Boon Power Chrono IA Spear
    profession: Chronomancer
    value:
      {
        "values2": { "Power": 3646, "Power2": 1018, "Burning": 0, "Bleeding": 0.95, "Poisoned": 0, "Torment": 0, "Confusion": 1.25 }
      }
    credit:
      - author: Cemox
        url: https://dps.report/yosV-20250624-190121_golem
        log: https://dps.report/yosV-20250624-190121_golem

  # impact
  - name: Boon Power Chrono GS
    profession: Chronomancer
    value:
      {
        "values2": { "Power": 3640, "Power2": 1118, "Burning": 0, "Bleeding": 0, "Poisoned": 0, "Torment": 0, "Confusion": 1.24 }
      }
    credit:
      - author: '[CnD] Tipcat'
        url: https://www.youtube.com/watch?v=Z8Ni8RZ458k
        log: https://dps.report/wbK9-20231111-134616_golem


  # includes June 24, 2025: added 2s bleed, torment, confusion per chaos vortex (0.628)
  - name: Alacrity Condi Mirage Staff
    profession: Mirage
    value:
      {
        "values2": { "Power": 1337, "Power2": 285, "Burning": 0, "Bleeding": 10.228, "Poisoned": 0.67, "Torment": 16.108, "Confusion": 18.218 }
      }
      # {
      #   "values2": { "Power": 1337, "Power2": 285, "Burning": 0, "Bleeding": 9.6, "Poisoned": 0.67, "Torment": 15.48, "Confusion": 17.59 }
      # }
    credit:
      - author: Mastro
        url: https://www.youtube.com/watch?v=p2hDluJb7oc
        log: https://dps.report/F2vf-20250422-202359_golem

  - name: Condi Mirage Staxe IH Oasis
    profession: Mirage
    value:
      {
        "values2": { "Power": 1781, "Power2": 450, "Burning": 1.72, "Bleeding": 4.28, "Poisoned": 0.61, "Torment": 26.42, "Confusion": 14.2 }
      }
    credit:
      - author: Mastro
        url: https://www.youtube.com/watch?v=iVbHIren_Kw
        log: https://dps.report/5eVE-20250827-031559_golem

  - name: Axe Mirage (Deception Torch)
    profession: Mirage
    value:
      {
        "values2": { "Power": 2050, "Power2": 453, "Burning": 1.08, "Bleeding": 7.88, "Poisoned": 0.46, "Torment": 22.88, "Confusion": 11.84 }
      }
    credit:
      - author: Mastro
        url: https://www.youtube.com/watch?v=uzQnOVI7QBc
        log: https://dps.report/q02e-20231004-212315_golem

  - name: Power Mirage
    profession: Mirage
    value:
      {
        "values2": { "Power": 3842, "Power2": 849, "Burning": 0, "Bleeding": 6, "Poisoned": 0, "Torment": 4.49, "Confusion": 3.58 }
      }
    credit:
      - author: beng / L3m0n
        url: https://www.youtube.com/watch?v=FxyrdWkW0dU
        log: https://dps.report/IiDV-20250305-162949_golem

  - name: Condi Chrono Scepter (Approx.)
    profession: Chronomancer
    value:
      {
        "values2": { "Power": 1712, "Power2": 478, "Burning": 2.26, "Bleeding": 1.25, "Poisoned": 1.29, "Torment": 28.41, "Confusion": 16.22 }
      }
    credit:
      - author: 'Ryan'
        url: https://www.youtube.com/watch?v=eYWEYECuU30
        log: https://dps.report/ErKq-20240818-033730_golem

  # rit: shoulders coat gloves leggings, domi midnight, mischief, rendang icicle
  - name: Boon Condi Chrono Scepter
    profession: Chronomancer
    value:
      {
        "values2": { "Power": 1894, "Power2": 426, "Burning": 1.57, "Bleeding": 4.99, "Poisoned": 0, "Torment": 6.75, "Confusion": 16.42 }
      }
    credit:
      - author: '[Vs] Nico'
        url: https://www.youtube.com/watch?v=wvL3EvG7iZs
        log: https://dps.report/WItI-20220804-134453_golem

  - name: Boon Condi Chrono Staff SC/D
    profession: Chronomancer
    value:
      {
        "values2": { "Power": 1788, "Power2": 463, "Burning": 1.8, "Bleeding": 1.08, "Poisoned": 1.16, "Torment": 21.04, "Confusion": 16.93 }
      }
    credit:
      - author: Mastro
        url: https://www.youtube.com/watch?v=mlo70yinQzc
        log: https://dps.report/Qv1n-20250510-031308_golem

  - name: Condi Chrono Staff SC/D
    profession: Chronomancer
    value:
      {
        "values2": { "Power": 1762, "Power2": 474, "Burning": 2.24, "Bleeding": 1.14, "Poisoned": 1.11, "Torment": 28.07, "Confusion": 17.22 }
      }
    credit:
      - author: Mastro
        url: https://www.youtube.com/watch?v=lPLC5WUdu08
        log: https://dps.report/sWjp-20250506-041500_golem

  - name: Condi Virtuoso Dueling
    profession: Virtuoso
    value:
      {
        "values2": { "Power": 2997, "Power2": 894, "Burning": 0, "Bleeding": 0, "Poisoned": 0, "Torment": 8.87, "Confusion": 3.22 }
      }
    credit:
      - author: Mastro
        url: https://www.youtube.com/watch?v=DkeftWZAUhc
        log: https://dps.report/Jnxp-20250211-205106_golem

  # https://optimizer.discretize.eu/?s=tC0aBKlpv1
  - name: Condi Virtuoso Chaos
    profession: Virtuoso
    value:
      {
        "values2": { "Power": 3146, "Power2": 9, "Burning": 0.52, "Bleeding": 3.08, "Poisoned": 0.27, "Torment": 7.58, "Confusion": 3.03 }
      }
    credit:
      - author: 'REMagic'
        url: https://www.youtube.com/watch?v=SgiCD0VZC1M
        log: https://dps.report/9Epv-20230630-181945_golem

  - name: Power Virtuoso Spear
    profession: Virtuoso
    value:
      {
        "values2": { "Power": 4245, "Power2": 1097, "Burning": 0, "Bleeding": 0, "Poisoned": 0, "Torment": 0, "Confusion": 0.52 }
      }
    credit:
      - author: 'Mastro'
        url: https://www.youtube.com/watch?v=eiA6Zmj23ok
        log: https://dps.report/SQov-20240821-152722_golem

  # accuracy, assassin legs, 4 precise (2007 prec)
  - name: Power Virtuoso GS
    profession: Virtuoso
    value:
      {
        "values2": { "Power": 3508, "Power2": 1106, "Burning": 0, "Bleeding": 0, "Poisoned": 0, "Torment": 0, "Confusion": 0.56 }
      }
    credit:
      - author: beng / L3m0n
        url: https://www.youtube.com/watch?v=dLs7hR9ZMFA
        log: https://dps.report/Wnpv-20230702-133715_golem

  # assassin shoulders 6 precise
  - name: Power Troubadour
    profession: Troubadour
    value:
      {
        "values2": { "Power": 3339, "Power2": 743, "Burning": 0, "Bleeding": 0, "Poisoned": 0, "Torment": 1.89, "Confusion": 0.91 }
      }
    credit:
      - author: Cemox
        url: https://www.youtube.com/watch?v=hf31Yf1tMM4
        log: https://dps.report/9Pfz-20251117-165436_golem

  - name: Condi Alacrity Scourge
    profession: Scourge
    value:
      {
        "values2": { "Power": 1656, "Power2": 0, "Burning": 1.77, "Bleeding": 13.54, "Poisoned": 5.16, "Torment": 13.25, "Confusion": 0 }
      }
    credit:
      - author: 'Sarulias'
        url: https://www.youtube.com/watch?v=6NFYb_RK5bQ
        log: https://dps.report/2bvf-20231014-100953_golem

  - name: Condi Scourge
    profession: Scourge
    value:
      {
        "values2": { "Power": 1799, "Power2": 0, "Burning": 2.94, "Bleeding": 12.77, "Poisoned": 4.91, "Torment": 13.37, "Confusion": 0 }
      }
    credit:
      - author: 'Incera'
        url: https://www.youtube.com/watch?v=mI7ky1a2-eQ
        log: https://dps.report/LzVj-20231003-151324_golem

  # "Reaper does approximately 29.28% of its damage outside of shroud" - https://discord.com/channels/380901000200060929/381160724409614356/828683461074092113
  # With YaaW this is closer to 33%
  # uses https://github.com/hobinjk/optimizer-scripts/blob/main/reaper.js for shroud power damage split
  - name: Power Reaper
    profession: Reaper
    value:
      {
        "values2": { "Power": 1580, "Power2": 2795, "Burning": 0, "Bleeding": 0.42, "Poisoned": 1.23, "Torment": 0, "Confusion": 0 }
      }
    credit:
      - author: 'Sarulias'
        url: https://www.youtube.com/watch?v=8ySVhgasBZ4
        log: https://dps.report/s1PP-20231007-214530_golem

  # uses https://github.com/hobinjk/optimizer-scripts/blob/main/reaper.js for shroud power damage split
  - name: Condi Reaper Spear
    profession: Reaper
    value:
      {
        "values2": { "Power": 3109, "Power2": 666, "Burning": 0.32, "Bleeding": 39.17, "Poisoned": 1.73, "Torment": 2.06, "Confusion": 0 }
      }
    credit:
      - author: 'Sarulias'
        url: https://www.youtube.com/watch?v=QlyneWeY3N0
        log: https://dps.report/HZw6-20240829-121726_golem

  # uses https://github.com/hobinjk/optimizer-scripts/blob/main/reaper.js for shroud power damage split
  - name: Condi Reaper Scepter
    profession: Reaper
    value:
      {
        "values2": { "Power": 1637, "Power2": 1288, "Burning": 0.31, "Bleeding": 47.83, "Poisoned": 2.69, "Torment": 3.76, "Confusion": 0 }
      }
    credit:
      - author: 'Sarulias'
        url: https://www.youtube.com/watch?v=9x6c3mBoHHE
        log: https://dps.report/O08l-20231002-152104_golem

  - name: DPS Harbinger
    profession: Harbinger
    value:
      {
        "values2": { "Power": 2314, "Power2": 0, "Burning": 2, "Bleeding": 7.93, "Poisoned": 6.36, "Torment": 20.8, "Confusion": 0.65 }
      }
    credit:
      - author: 'Sarulias'
        url: https://www.youtube.com/watch?v=ZOC2RsEFrTY
        log: https://dps.report/IpSJ-20231002-151234_golem

  - name: Quickness Condi Harbinger
    profession: Harbinger
    value:
      {
        "values2": { "Power": 2497, "Power2": 0, "Burning": 1.94, "Bleeding": 8.17, "Poisoned": 6.15, "Torment": 18.37, "Confusion": 0.63 }
      }
    credit:
      - author: 'Sarulias'
        url: https://www.youtube.com/watch?v=ER3qccGutd0
        log: https://dps.report/IZRW-20240206-201123_golem

  - name: Quickness Power Harbinger
    profession: Harbinger
    value:
      {
        "values2": { "Power": 1696, "Power2": 1938, "Burning": 0.55, "Bleeding": 0.55, "Poisoned": 0.55, "Torment": 10.11, "Confusion": 0.55 }
      }
    credit:
      - author: 'Sarulias'
        url: https://www.youtube.com/watch?v=CHdwmsq15f8
        log: https://dps.report/BCeZ-20240822-094804_golem

  # uses https://github.com/hobinjk/optimizer-scripts/blob/main/reaper.js for shroud power damage split
  - name: Power Harbinger
    profession: Harbinger
    value:
      {
        "values2": { "Power": 1778, "Power2": 2149, "Burning": 0.67, "Bleeding": 0.68, "Poisoned": 1.51, "Torment": 9.99, "Confusion": 0.67 }
      }
    credit:
      - author: 'Sarulias'
        url: https://www.youtube.com/watch?v=ZGC5WTTHmi4
        log: https://dps.report/Mu8J-20240821-222344_golem

  - name: Power Ritualist
    profession: Ritualist
    value:
      {
        "values2": { "Power": 5693, "Power2": 0, "Burning": 0, "Bleeding": 0, "Poisoned": 0, "Torment": 0, "Confusion": 0 }
      }
    credit:
      - author: 'Sarulias'
        url: https://www.youtube.com/watch?v=iAsnh2kvV7o
        log: https://dps.report/TlPB-20251213-105910_golem

  - name: Condi Deadeye A/D
    profession: Deadeye
    value:
      {
        "values2": { "Power": 3552, "Power2": 0, "Burning": 0, "Bleeding": 7.43, "Poisoned": 25.79, "Torment": 4.95, "Confusion": 0 }
      }
    credit:
      - author: 'Incera'
        url: https://www.youtube.com/watch?v=hZZMpKMWnbE
        log: https://dps.report/KuD7-20240530-002512_golem

  - name: Condi Deadeye A/D (no allies)
    profession: Deadeye
    value:
      {
        "values2": { "Power": 3554, "Power2": 0, "Burning": 0, "Bleeding": 7.24, "Poisoned": 21.34, "Torment": 6.47, "Confusion": 0 }
      }
    credit:
      - author: 'Incera'
        url: https://www.youtube.com/watch?v=hZZMpKMWnbE
        log: https://dps.report/4GTi-20240530-005615_golem

  - name: Quickness Condi Deadeye Spear
    profession: Deadeye
    value:
      {
        "values2": { "Power": 3173, "Power2": 0, "Burning": 0, "Bleeding": 14.14, "Poisoned": 20.49, "Torment": 0.51, "Confusion": 0 }
      }
    credit:
      - author: 'Incera'
        url: https://dps.report/dUOv-20240821-180709_golem
        log: https://dps.report/dUOv-20240821-180709_golem

  - name: Condi Thief Spear
    profession: Thief
    value:
      {
        "values2": { "Power": 3216, "Power2": 0, "Burning": 0, "Bleeding": 12.59, "Poisoned": 26.96, "Torment": 0, "Confusion": 0 }
      }
    credit:
      - author: '[LCs] Seisan'
        url: https://www.youtube.com/watch?v=GdOW62dD8jc
        log: https://dps.report/pouZ-20241123-211217_golem

  - name: Condi Thief A/D
    profession: Thief
    value:
      {
        "values2": { "Power": 3034, "Power2": 0, "Burning": 0, "Bleeding": 18.28, "Poisoned": 17.74, "Torment": 3.02, "Confusion": 0 }
      }
    credit:
      - author: '[LCs] Seisan'
        url: https://www.youtube.com/watch?v=mZ-c8Okn0k8
        log: https://dps.report/xLxn-20240627-154041_golem

  - name: Power Daredevil Staff
    profession: Daredevil
    value:
      {
        "values2": { "Power": 3424, "Power2": 0, "Burning": 0, "Bleeding": 0.67, "Poisoned": 3.25, "Torment": 0, "Confusion": 0 }
      }
    credit:
      - author: 'Left'
        url: https://www.youtube.com/watch?v=7xzW6wLSb7s
        log: https://www.dps.report/7Qij-20250624-165156_golem

  - name: Condi Daredevil D/D (No Allies)
    profession: Daredevil
    value:
      {
        "values2": { "Power": 1355, "Power2": 0, "Burning": 0, "Bleeding": 31.29, "Poisoned": 10.8, "Torment": 3.97, "Confusion": 0 }
      }
    credit:
      - author: 'Alcatraz'
        url: https://www.youtube.com/watch?v=yun-a_2QdQE
        log: https://dps.report/PMEO-20250629-050626_golem

  # messed up log start from mesmer existing
  # scuffed approximation by multiplying with full duration / target combat duration
  - name: Condi Daredevil D/D
    profession: Daredevil
    value:
      {
        "values2": { "Power": 1728, "Power2": 0, "Burning": 0, "Bleeding": 32.35, "Poisoned": 13.46, "Torment": 3.4, "Confusion": 0 }
      }
    credit:
      - author: 'Alcatraz'
        url: https://www.youtube.com/watch?v=yun-a_2QdQE
        log: https://dps.report/x9oZ-20250629-021609_golem

  - name: Power Deadeye Rifle
    profession: Deadeye
    value:
      {
        "values2": { "Power": 4065, "Power2": 0, "Burning": 0, "Bleeding": 0.98, "Poisoned": 2.17, "Torment": 0.27, "Confusion": 0 }
      }
    credit:
      - author: 'Incera'
        url: https://www.youtube.com/watch?v=W1yc6I7DfAs
        log: https://dps.report/FyD0-20240322-133853_golem

  - name: Power Deadeye Spear
    profession: Deadeye
    value:
      {
        "values2": { "Power": 3705, "Power2": 0, "Burning": 0, "Bleeding": 10.41, "Poisoned": 8.77, "Torment": 1.37, "Confusion": 0 }
      }
    credit:
      - author: 'Iskarel'
        url: https://www.youtube.com/watch?v=Rj7plV06ws4
        log: https://dps.report/7Qst-20240901-201424_golem

  - name: Quickness Power Deadeye Spear
    profession: Deadeye
    value:
      {
        "values2": { "Power": 3670, "Power2": 0, "Burning": 0, "Bleeding": 8.39, "Poisoned": 9, "Torment": 0.41, "Confusion": 0 }
      }
    credit:
      - author: 'Iskarel'
        url: https://www.youtube.com/watch?v=QEuiCecSnx8
        log: https://dps.report/DIWM-20240823-013059_golem

  - name: Power Deadeye Daggers BQoBK
    profession: Deadeye
    value:
      {
        "values2": { "Power": 3192, "Power2": 0, "Burning": 0, "Bleeding": 3.86, "Poisoned": 6.7, "Torment": 0, "Confusion": 0 }
      }
    credit:
      - author: 'Iskarel'
        url: https://www.youtube.com/watch?v=roV_hRP7AVY
        log: https://dps.report/tpmp-20221130-042530_golem

  - name: Power Deadeye Rifle Silent Scope
    profession: Deadeye
    value:
      {
        "values2": { "Power": 3907, "Power2": 0, "Burning": 0, "Bleeding": 0, "Poisoned": 0.95, "Torment": 0.24, "Confusion": 0 }
      }
    credit:
      - author: 'Iskarel'
        url: https://www.youtube.com/watch?v=iou6Wx7NQ4w
        log: https://dps.report/OK9l-20230214-214155_golem

  - name: Condi Specter Spear (Allies)
    profession: Specter
    value:
      {
        "values2": { "Power": 3206, "Power2": 0, "Burning": 0.24, "Bleeding": 12.24, "Poisoned": 21.26, "Torment": 6.69, "Confusion": 0 }
      }
    credit:
      - author: 'Incera'
        url: https://dps.report/4PUw-20240821-170414_golem
        log: https://dps.report/4PUw-20240821-170414_golem

  # 1.72 torment proc rate (from evtc tool applied to previous log)
  - name: Condi Specter SC/D (Allies)
    profession: Specter
    value:
      {
        "values2": { "Power": 2437, "Power2": 0, "Burning": 0, "Bleeding": 2.53, "Poisoned": 14.31, "Torment": 16.75, "Confusion": 0 }
      }
    credit:
      - author: 'Incera'
        url: https://www.youtube.com/watch?v=5mBLfyDqmSo
        log: https://dps.report/dxtA-20240624-182549_golem

  # https://optimizer.discretize.eu/?s=wpWaF0plv1
  # bugged log: has leeching venoms
  # 1.52 torment proc rate (from evtc tool)
  - name: DPS Barrier Specter SC/D (Allies)
    profession: Specter
    value:
      {
        "values2": { "Power": 2163, "Power2": 0, "Burning": 0, "Bleeding": 2.55, "Poisoned": 15.94, "Torment": 20.03, "Confusion": 0 }
      }
    credit:
      - author: 'Iskarel'
        url: https://www.youtube.com/watch?v=xYsGEFE6jn0
        log: https://dps.report/pfgp-20220827-121511_golem

  # demons + skewer (102% torment duration)
  # bugged log: has leeching venoms
  # larcenous torment isn't in logs
  - name: Alacrity Condi Specter SC/D (allies)
    profession: Specter
    value:
      {
        "values2": { "Power": 2015, "Power2": 0, "Burning": 0, "Bleeding": 5.44, "Poisoned": 14.35, "Torment": 15.74, "Confusion": 0 }
      }
    credit:
      - author: 'Iskarel'
        url: https://www.youtube.com/watch?v=GXytKrWFJ40
        log: https://dps.report/YFvl-20250830-112530_golem

  - name: Alacrity Condi Specter D/D (allies)
    profession: Specter
    value:
      {
        "values2": { "Power": 1660, "Power2": 0, "Burning": 0, "Bleeding": 22.39, "Poisoned": 9.97, "Torment": 7.99, "Confusion": 0 }
      }
    credit:
      - author: Iskarel
        url: https://www.youtube.com/watch?v=CejAR-crRCw
        log: https://dps.report/e3gK-20250830-145722_golem

  - name: Alacrity Power Antiquary Spear
    profession: Antiquary
    value:
      {
        "values2": { "Power": 4467, "Power2": 0, "Burning": 10.24, "Bleeding": 4.28, "Poisoned": 4.95, "Torment": 2.41, "Confusion": 0 }
      }
    credit:
      - author: '[LCs] Seisan'
        url: https://www.youtube.com/watch?v=wSr8WlnZIKE
        log: https://dps.report/dIE0-20251211-204328_golem

  - name: Condi Antiquary Spear (Solo)
    profession: Antiquary
    value:
      {
        "values2": { "Power": 4449, "Power2": 0, "Burning": 11.26, "Bleeding": 8.56, "Poisoned": 12.78, "Torment": 2.81, "Confusion": 0 }
      }
    credit:
      - author: '[LCs] Seisan'
        url: https://www.youtube.com/watch?v=5IRgdbTrpzg
        log: https://dps.report/3MAR-20251214-150318_golem


  # add: 4 spider venom casts * 6 stacks * 3s poison * 4 allies in 71s = 4.06 poison coefficient
  - name: Condi Antiquary Spear (Allies)
    profession: Antiquary
    value:
      {
        "values2": { "Power": 4449, "Power2": 0, "Burning": 11.26, "Bleeding": 8.56, "Poisoned": 16.84, "Torment": 2.81, "Confusion": 0 }
      }
    credit:
      - author: '[LCs] Seisan'
        url: https://www.youtube.com/watch?v=5IRgdbTrpzg
        log: https://dps.report/3MAR-20251214-150318_golem

  - name: Quickness Condi Firebrand A/T P/P
    profession: Firebrand
    value:
      {
        "values2": { "Power": 2094, "Power2": 0, "Burning": 13.87, "Bleeding": 8.54, "Poisoned": 0, "Torment": 0.21, "Confusion": 0 }
      }
    credit:
      - author: Chimera
        log: https://dps.report/qhoR-20260509-162737_golem
        url: https://www.youtube.com/watch?v=Vu6cmxLg8MI
